<template>
  <view class="cabin-container">
    <view
      wx:for="{{cabins}}"
      wx:key="index"
      class="cabin-item"
    >
      <view
        class="cabin-item-inner"
        wx:class="{{ item.key === cabin ? 'active' : '' }}"
        bindtap="onCabinTap(item)"
      >{{item.text}}</view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'
  import store from '@/store'

  createComponent({
    computed: {
      ...store.mapState({
        flightsQuery: 'flights.flightsQuery',
      }),
      cabin() {
        return this.flightsQuery.cabin || 0
      },
      cabins() {
        return [{
          key: 0,
          text: '经济舱',
        }, {
          key: 1,
          text: '公务舱/头等舱',
        }]
      }
    },
    methods: {
      ...store.mapMutations({
        setFlightsQuery: 'flights.setFlightsQuery',
      }),
      onCabinTap({ key }) {
        this.setFlightsQuery({
          cabin: key,
        })
      }
    }
  })
</script>

<style lang='stylus' scoped>
.cabin-container
  height 60px
  @extend .flex-center
  font-size 12px
  color #666
  font-family PingFang SC
  font-weight 400
  .cabin-item
    background #F2F6F9
    &:first-child
      border-top-left-radius 6px
      border-bottom-left-radius 6px
      padding 2px 0 2px 2px
    &:last-child
      border-top-right-radius 6px
      border-bottom-right-radius 6px
      padding 2px 2px 2px 0
    &-inner
      padding 4px 12px
      border-radius 5px
      &.active
        color #222
        background #fff
        font-weight 500
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
    }
  }
</script>
